import { mixpanel } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES } from '../../../../shared/mixpanel';
import store from '../../store';

type Location = 'Static' | 'Sticky';
type Field = 'Brand name' | 'Slogan';

type Payload = {
    location: Location;
    field: Field;
};

/**
 * The user changed the brand name or slogan text
 */
export const reportTextFieldsChanged = ({ location, field }: Payload) => {
    mixpanel.track('Logo Maker - MPI - Text fields Changed', {
        ...store.brief.getData(),
        ...store.user.getData(),
        ...store.listingsType.getData(),
        [MIXPANEL_EVENT_PROPERTIES.CHANGE_LOCATION]: location,
        [MIXPANEL_EVENT_PROPERTIES.FIELD]: field,
    });
};
